export default __webpack_public_path__ + "static/media/activeBranded.0519a813.svg";